<script setup lang="ts">
defineProps<{
  items: StoryBlokArticle[]
}>()

const appConfig = useAppConfig()
const blog = appConfig.blog
</script>

<template>
  <StoryblokLink
    v-for="(item, i) in items"
    :key="i"
    :to="`${blog.url}/${item.slug}`"
    class="my-5 p-2.5 mt-2.5 flex rounded-xl relative transition ease-in-out hover:bg-primary hover:bg-opacity-15"
  >
    <div class="flex-shrink-0">
      <StoryblokImage :src="item.content.image" width="100" height="100" class="rounded-xl" />
    </div>
    <div class="px-5 flex flex-col">
      <div class="text-gray-dark flex pb-2.5 text-sm">
        <span>{{ useFormatDate(item.content.publishDate, 'd. M. yyyy') }}</span>
      </div>
      <div class="font-semibold flex-1 line-clamp-2">
        {{ item.content.title }}
      </div>
      <span class="text-secondary-active hover:underline flex items-center">{{ blog.readArticle }} <AppIcon class="ml-1" size="12" icon="far-angle-right" /></span>
    </div>
    <div v-if="i > 0" class="absolute w-full h-1px bg-primary bg-opacity-40 -top-2.5 left-0" />
  </StoryblokLink>
</template>
